<template>
<div>
</div>
</template>
<script>
export default {
  name: 'index',
  data () {
    return {
      path: ''
    }
  },
  created () {
    this.$axios.get(`/auth-api/roles/getHomePageMenusByUserId`)
      .then((res) => {
        //  可能是个数组。如果数组，全展示。第一个展示待办页
        let homePage
        if (res.data.length) {
          homePage = []
          let list = JSON.parse(JSON.stringify(this.$router.options.routes[0].children))
          res.data.forEach((el, index) => {
            let arr = el.link.split('/')
            let target = list.filter(n => n.path.indexOf(arr[1]) !== -1)[0]
            let json = {
              path: '/main' + el.link,
              id: el.id,
              name: target ? target.name : '',
              title: el.name,
              fullPath: `/main${el.link}?token=${this.$route.query.token}`,
              query: this.$route.query,
              params: arr[2] ? {id: arr[2]} : {}
            }
            // 待办会被放在第一个
            if (el.name === '待办流程') {
              homePage.unshift(json)
            } else {
              homePage.push(json)
            }
          })
          // 企业微信过来的需要直接打开待办标签页
          if (this.$route.query.isFromQYWXNotice) {
            // 待办流程标签页不存在时手动添加一个虚拟的
            if (!homePage.find(item => item.path && item.path.includes('process-doingTasks'))) {
              homePage.unshift({
                path: '/main/process-doingTasks',
                id: this.$UUID.create(),
                name: '待办流程',
                title: '待办流程',
                fullPath: `/main/process-doingTasks?token=${this.$route.query.token}`,
                query: this.$route.query
              })
            }
          }
          homePage[0].path = homePage[0].path.slice(5)
          sessionStorage.setItem('homepage', JSON.stringify(homePage))
          this.$router.push({path: '/main' + homePage[0].path, query: this.$route.query.isFromQYWXNotice ? this.$route.query : {}})
        } else {
          homePage = [{}]
          sessionStorage.setItem('homepage', JSON.stringify(homePage))
        }
      })
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Index.vue